import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { SearchSubItemComponent } from '../search-sub-item/search-sub-item.component';

@Component({
  selector: 'app-stock',
  templateUrl: './stock.component.html',
  styleUrls: ['./stock.component.css']
})
export class StockComponent implements OnInit {

  model = {
    'table_name': 'stock', 'stock_id': '0', 'stock_no': '', 'branch_id': '', 'store_id': '0',
    'sub_item_id': '', 'expiry_date': '', 'quantity': '', 'comment': ''
  };
  private dp = [];
  branchList = [];
  storeList = [];
  store = [];
  subItemDialogRef: MatDialogRef<SearchSubItemComponent>;
  displayedColumns = ['sub_item_no', 'main_item_name', 'main_item_name_en', 'item_cat_name', 'item_subcat_name', 'stock_no', 'quantity', 'expiry_date'];
  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<StockComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any, public dialog: MatDialog) { }


  ngOnInit() {
    let query = "SELECT * FROM `branch` WHERE `status`='1'";
    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.branchList = data.data['list'];
      });
    let query1 = "SELECT * FROM `store` WHERE `status`='1'";
    let obj1 = { cmd: 'getList', query: query1 };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj1)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.store = data.data['list'];
        if (this.dialog_data != null)
          this.getStore();
      });

    if (this.dialog_data != null) {
      document.getElementById("search_sub_item").style.display = 'none';
      this.model = this.dialog_data['0'];
      this.dp.push(this.dialog_data['1']);
      this.dataSource = new MatTableDataSource(this.dp);
      this.dataSource.sort = this.sort;
    }
  }

  getStore() {
    this.storeList = [];
    this.store.forEach(element => {
      if (element['branch_id'] == this.model['branch_id'])
        this.storeList.push(element);
    });
  }

  add() {
    if (this.model['store_id'] != '0' && this.dp.length != 0) {
      let values = [];
      let obj;

      //add
      if (this.model['stock_id'] == '0') {

        this.dp.forEach((element) => {
          let quantity = document.getElementById('quantity' + element.sub_item_id) as HTMLInputElement;
          let stock_no = document.getElementById('stock_no' + element.sub_item_id) as HTMLInputElement;
          let expiry_date_v = document.getElementById('expiry_date' + element.sub_item_id) as HTMLInputElement;
          let expiry_date_d = new Date(expiry_date_v.value);
          let expiry_date = (expiry_date_d.getFullYear() + "-" + (expiry_date_d.getMonth() + 1) + "-" + expiry_date_d.getDate());
          values.push({
            'table_name': this.model['table_name'], 'store_id': this.model['store_id'],
            'sub_item_id': element.sub_item_id, 'expiry_date': expiry_date, 
            'quantity': quantity.value, 'stock_no': stock_no.value, 'comment': this.model['comment']
          });
        });

        obj = { cmd: 'add', values: values };
      }

      //updae
      else {

        delete this.model['branch_id'];

        let quantity = document.getElementById('quantity' + this.model['sub_item_id']) as HTMLInputElement;
        let stock_no = document.getElementById('stock_no' + this.model['sub_item_id']) as HTMLInputElement;
        let expiry_date_d = document.getElementById('expiry_date' + this.model['sub_item_id']) as HTMLInputElement;
        let expiry_date = new Date(expiry_date_d.value);

        this.model.expiry_date = (expiry_date.getFullYear() + "-" + (expiry_date.getMonth() + 1) + "-" + expiry_date.getDate());
        this.model.stock_no = stock_no.value;
        this.model.quantity = quantity.value;
        values.push(this.model);

        let where = [{ 'stock_id': this.model['stock_id'] }];
        obj = { cmd: 'update', values: values, where: where };
      }


      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(" تمت العملية بنجاح ");

         /*   //update stock no
            if (obj.cmd == 'add') {
              data.status['msg'].forEach((element) => {
                let stock_id = element.id;

                let where = [];
                let value1 = [];
                where.push({ 'stock_id': stock_id });
                value1.push({ 'table_name': this.model['table_name'], 'stock_no': stock_id });
                let obj1 = { cmd: 'update', values: value1, where: where };
                this.utils.invokeHttp(this.applicationConstants.generalFile, obj1)
                  .subscribe(data => {
                    this.applicationConstants.appComp.hideBusyCursor();
                  });
              });
            }*/
            this.dialogRef.close(this.dialog_data);
          }
          else if (data.status['type'] != 'success') {
            alert(" حدث خطأ الرجاء المحاولة مرة أخرى ");
          }
        });
    }
    else if (this.model['store_id'] == '0')
      alert(" الرجاء اختيار المستودع ");

    else if (this.dp.length == 0)
      alert(" الرجاء اختيار الأصناف ");
  }

  searchSubItem() {
    this.subItemDialogRef = this.dialog.open(SearchSubItemComponent, {
      hasBackdrop: false,
    });
    this.subItemDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != undefined) {
          this.dp = result;
          this.dataSource = new MatTableDataSource(this.dp);
          this.dataSource.sort = this.sort;
        }
      });
  }

  cancel() {
    this.dialogRef.close(this.dialog_data);
    if (this.subItemDialogRef)
      this.subItemDialogRef.close();
  }

}
